import 'bootstrap/dist/css/bootstrap.css';
//import 'react-table/react-table.css'
import 'react-datetime/css/react-datetime.css';

import { setAxiosDefaults } from './Utils/AuthenticationHandler';
import configureReactTableDefaults from './Utils/ConfigureReactTableDefaults';

import React from 'react';
import { createRoot } from 'react-dom/client';
import Root from './components/Root';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

setAxiosDefaults();
configureReactTableDefaults();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(<Root />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
